<template>
  <!-- Add Stock -->
  <div class="modal fade" id="add-units">
    <div class="modal-dialog modal-dialog-centered stock-modal">
      <div class="modal-content shadow-lg border-0 rounded-4">
        <div class="modal-body p-4 p-md-5">
          <div class="d-flex align-items-start justify-content-between mb-4">
            <div>
              <p class="stock-eyebrow mb-1">Inventaire</p>
              <h4 class="stock-title mb-1">Ajouter un stock</h4>
              <p class="stock-subtitle">
                Sélectionnez l'entrepôt, le produit et ajustez la quantité disponible.
              </p>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <form @submit.prevent="submitForm" class="stock-form">
            <div class="row g-4">
              <div class="col-md-6 col-12">
                <label class="stock-label">Entrepôt</label>
                <vue-select
                  :options="warehouseData"
                  id="lobar"
                  placeholder="Choisir un entrepôt"
                  v-model="selectedWarehouse"
                />
                <small class="text-muted">Lieu où sera affecté le stock.</small>
              </div>
              <div class="col-md-6 col-12">
                <label class="stock-label">Produit</label>
                <vue-select
                  :options="productsData"
                  id="selosy"
                  placeholder="Choisir un produit"
                  v-model="selectedProduct"
                />
                <small class="text-muted">Produit ou service concerné.</small>
              </div>
              <div class="col-12">
                <label class="stock-label">Quantité</label>
                <input
                  type="number"
                  min="0"
                  class="form-control stock-input"
                  placeholder="0"
                  v-model.number="form.quantite"
                  required
                />
              </div>
            </div>

            <div class="stock-footer mt-4">
              <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal">
                Annuler
              </button>
              <button type="submit" class="btn btn-primary px-4">
                Enregistrer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Stock -->

  <!-- Edit Stock -->
  <div class="modal fade" id="edit-units">
    <div class="modal-dialog modal-dialog-centered stock-modal">
      <div class="modal-content shadow-lg border-0 rounded-4">
        <div class="modal-body p-4 p-md-5">
          <div class="d-flex align-items-start justify-content-between mb-4">
            <div>
              <p class="stock-eyebrow mb-1">Inventaire</p>
              <h4 class="stock-title mb-1">Modifier le stock</h4>
              <p class="stock-subtitle">
                Ajustez rapidement les quantités enregistrées pour ce produit.
              </p>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <form @submit.prevent="submitForm1" class="stock-form">
            <div class="row g-4">
              <div class="col-md-6 col-12">
                <label class="stock-label">Entrepôt</label>
                <vue-select
                  :options="warehouseData"
                  id="lobars"
                  placeholder="Choisir un entrepôt"
                  v-model="selectedWarehouse"
                />
              </div>
              <div class="col-md-6 col-12">
                <label class="stock-label">Produit</label>
                <vue-select
                  :options="productsData"
                  id="selosyd"
                  placeholder="Choisir un produit"
                  v-model="selectedProduct"
                />
              </div>
              <div class="col-12">
                <label class="stock-label">Quantité</label>
                <input
                  type="number"
                  min="0"
                  class="form-control stock-input"
                  placeholder="0"
                  v-model.number="form1.quantite"
                  required
                />
              </div>
            </div>

            <div class="stock-footer mt-4">
              <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal">
                Annuler
              </button>
              <button type="submit" class="btn btn-primary px-4">
                Enregistrer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Stock -->
</template>

<script>
import Swal from "sweetalert2";
import { getWarehouseData, getProductsData } from "@/services/productsService";
import { createStock, updateStock } from "@/services/stockService";
import { Modal } from "bootstrap";
import { decodeToken } from "@/services/jwtService";
import { toast } from "vue3-toastify";
const warehouseData = [];
const warehouseIds = [];
const productsData = [];
const productsIds = [];
export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        societe_id: null,
        produit_id: null,
        quantite: null,
        entrepot_id: null,
      },
      form1: {
        id: null,
        societe_id: null,
        produit_id: null,
        quantite: null,
        entrepot_id: null,
      },
      warehouseData,
      warehouseIds,
      productsData,
      productsIds,
      selectedProduct: null,
      selectedWarehouse: null,
    };
  },
  methods: {
    showConfirmation() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            confirmButtonClass: "btn btn-success",
          });
        }
      });
    },
    async getWarehouseData() {
      this.warehouseData = [];
      this.warehouseIds = [];
      if (localStorage.getItem("warehouses") != null) {
        const data = JSON.parse(localStorage.getItem("warehouses"));
        data.map((m) => {
          this.warehouseData.push(m.nom);
          this.warehouseIds.push(m.id);
        });
      } else {
        try {
          const data = await getWarehouseData();
          data.map((m) => {
            this.warehouseData.push(m.nom);
            this.warehouseIds.push(m.id);
          });
        } catch (error) {
          console.error(error);
          toast.error(error.response.data.message);
          toast.error(error.response.data.error);
        }
      }
    },
    getWarehouseID(option) {
      let index = this.warehouseData.indexOf(option);
      if (index != -1) {
        return this.warehouseIds[index];
      }
      return index;
    },
    async getProductsData() {
      this.productsData = [];
      this.productsIds = [];
      if (localStorage.getItem("products") != null) {
        const data = JSON.parse(localStorage.getItem("products"));
        data.map((m) => {
          this.productsData.push(m.nom);
          this.productsIds.push(m.id);
        });
      } else {
        try {
          const data = await getProductsData();
          data.map((m) => {
            this.productsData.push(m.nom);
            this.productsIds.push(m.id);
          });
        } catch (error) {
          console.error(error);
          toast.error(error.response.data.message);
          toast.error(error.response.data.error);
        }
      }
    },
    getProductsId(option) {
      let index = this.productsData.indexOf(option);
      if (index != -1) {
        return this.productsIds[index];
      }
      return index;
    },
    resetAddForm() {
      this.form.quantite = null;
      this.selectedProduct = null;
      this.selectedWarehouse = null;
    },
    async submitForm() {
      try {
        const user = decodeToken(localStorage.getItem("access_token"));
        this.form.societe_id = user.societe_id;
        this.form.entrepot_id = this.getWarehouseID(this.selectedWarehouse);
        this.form.produit_id = this.getProductsId(this.selectedProduct);

        await createStock({
          societe_id: this.form.societe_id,
          produit_id: this.form.produit_id,
          quantite: this.form.quantite,
          entrepot_id: this.form.entrepot_id,
        });
        this.$emit("stock-added");

        const modalElement = document.getElementById("add-units");
        const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
        this.resetAddForm();
        toast.success("Stock ajouté avec succès !");
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Erreur lors de l'ajout du stock");
      }
    },
    async submitForm1() {
      try {
        this.form1.entrepot_id = this.getWarehouseID(this.selectedWarehouse);
        this.form1.produit_id = this.getProductsId(this.selectedProduct);
        await updateStock(this.form1.id, {
          societe_id: this.form1.societe_id,
          produit_id: this.form1.produit_id,
          quantite: this.form1.quantite,
          entrepot_id: this.form1.entrepot_id,
        });
        this.$emit("stock-updated");

        const modalElement = document.getElementById("edit-units");
        const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
        toast.success("Stock mis à jour");
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Erreur lors de la mise à jour du stock");
      }
    },
  },
  mounted() {
    this.getWarehouseData();
    this.getProductsData();
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        this.form1.id = newData.id;
        this.form1.societe_id = newData.societe_id;
        this.form1.produit_id = newData.produit_id;
        this.form1.quantite = newData.quantite;
        this.form1.entrepot_id = newData.entrepot_id;
        this.selectedProduct = newData?.produit_nom || null;
        this.selectedWarehouse = newData?.entrepot_nom || null;
      },
    },
  },
};
</script>

<style scoped>
.stock-modal {
  max-width: 760px;
}

.stock-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #0f172a;
}

.stock-eyebrow {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
}

.stock-subtitle {
  font-size: 0.9rem;
  color: #64748b;
  margin-bottom: 0;
}

.stock-label {
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
  display: block;
}

.stock-input {
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.6);
  padding: 12px 14px;
}

.stock-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.stock-footer .btn {
  border-radius: 10px;
  font-weight: 600;
}

.btn-close {
  background-color: rgba(226, 232, 240, 0.8);
  border-radius: 14px;
  padding: 10px;
}

@media (max-width: 575px) {
  .stock-modal {
    margin: 0 10px;
  }

  .stock-title {
    font-size: 1.25rem;
  }
}
</style>
